<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="title" :actions="card_actions" :bus="bus">
            <trax-setting-aircraft-crud-table :bus="bus" :id="id" :endpoint="endpoint">
            </trax-setting-aircraft-crud-table>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-setting-aircraft-crud-form :bus="bus" :id="id+'-edit'" :toastr-id="id+'-toastr'"
                :endpoint="endpoint" :code-prefix="codePrefix">
            </trax-setting-aircraft-crud-form>
        </trax-ui-modal-default>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>

    </div>
</template>

<script>
    export default {

        props: {
            id: null,
            resource: null,
            titleKey: null
        },

        data: function() {
            return {
                lang: lang,
                endpoint: app_url+"polaris/api/front/"+this.resource,
                card_actions: [
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                bus: new Vue()
            }
        },

        computed: {

            title() {
                return this.lang.polaris.settings[this.titleKey];
            },

            // The prefix the back-end adds to the code: displayed as a hint in the form.
            codePrefix() {
                return this.resource == 'aircraft-categories' ? 'cat_' : 'type_';
            }
        }

    }
</script>
